
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth,apikey } from '../../constants/api';
import {
    SERVICE_FETCH,
} from '../actions';

import {
    serviceSuccess,
    serviceFail,
} from './actions';

const serviceFetchAsync = async (data) =>

	 await API.get('/service',
	 {
      headers : {
        'Content-Type': 'application/json',
		  'apikey': '87cdf9229caf9a7fa3fd1403bcc5dd97',
		  'useId': data,
      }
    })
        .then(data => data)
        .catch(error => error);



//* Get service List
function* serviceFetch({ payload }) {

    try {
		 const{ servicelist } = payload;
		  const serviceFetch = yield call(serviceFetchAsync , servicelist);
        if (serviceFetch.data.StatusCode === "0000") {
            yield put(serviceSuccess(serviceFetch.data.ResultValues));
        } else {
            yield put(serviceFail(serviceFetch.data.Message));
        }
    } catch (error) {
        yield put(serviceFail(error));
    }
}



export function* watchServiceFetch() {
    yield takeEvery(SERVICE_FETCH, serviceFetch)
}

export default function* rootSaga() {
    yield all([
        fork(watchServiceFetch),
    ]);
}
